export default "__VITE_ASSET__WdzwpXth__"